import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

import ReCAPTCHA from "react-google-recaptcha";
import Input from '@mui/material/Input';

import { RECAPATCHA_KEY } from "../../../constants";
import { i18n } from '../../../config/i18n';


const Recaptcha = ({ name, reset, setValue, ...props}) => {
    const elmRef = useRef();

    useEffect(() => {
        if(reset) {
            elmRef.current.reset();
        }
    }, [reset])

    return (
        <>
            <ReCAPTCHA
                ref={elmRef}
                sitekey={RECAPATCHA_KEY}
                onChange={(token) => setValue(name, token)}
                hl={i18n.language}
            />
            <Input
                id="recaptcha"
                type="hidden"
                name={name}
                {...props}
            />
        </>
    );
}

Recaptcha.propTypes = {
    name: PropTypes.string,
    reset: PropTypes.bool,
    setValue: PropTypes.func.isRequired
};
  
Recaptcha.defaultProps = {
    name: '_recaptcha',
    reset: false
};

export default Recaptcha